import { Lock } from "lucide-react";

const PLAN_LABELS = {
  free: "Free",
  visible: "Visible",
  optimized: "Optimized",
  dominant: "Dominant",
  enterprise: "Enterprise",
};

const UpgradePrompt = ({ requiredPlan = "optimized", featureName = "this feature" }) => (
  <div className="flex flex-col items-center justify-center py-12 gap-4 text-center">
    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
      <Lock className="w-6 h-6 text-primary" />
    </div>
    <div>
      <p className="font-bold text-on-surface">
        {PLAN_LABELS[requiredPlan] || requiredPlan} plan required
      </p>
      <p className="text-sm text-on-surface-variant mt-1">Upgrade to access {featureName}.</p>
    </div>
    <a
      href="/pricing"
      className="px-5 py-2 bg-primary text-on-primary rounded-xl text-sm font-bold hover:opacity-90 transition-opacity"
    >
      View Plans
    </a>
  </div>
);

export default UpgradePrompt;
